// @ts-nocheck
/* eslint-disable */
import { _ } from "~/route/globals";
import ItemPoint from "~/route/item/point";
import ItemBoat from "~/route/item/boat";
import ItemEmpty from "~/route/item/empty";
import ItemPlus from "~/route/item/plus";
import ItemPubt from "~/route/item/pubt";
import ItemTrip from "~/route/item/trip";
import { ROUTE_CONST } from "~/route/const";
import RouteReorder from "~/route/reorder";
import { paramTypeToSvg } from "~/route/utils";
import { createRouteBookingLink } from "./booking-link";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import { icon, node } from "~/util/dom";
import { timeWithUserSpeed } from "~/util/user-speed";
import { getCriterion } from "~/util/route";

export interface IRouteCuriosity {
	start: number;
	end: number;
	name: string;
	endVirtual: boolean;
	popup: {
		mark: [number, number];
		index: number;
		azimuth: number;
	}
}

export interface IRouteClosure extends IRouteCuriosity {
	type: "bus_only" | "no_entry" | "closed_comp" | "closed_comp2" | "service_road" | "pedestrian" | "bike_eta" | "military" | "game_reserve" | "nat_park" | "nat_reservation" | "water_protection" | "private_property" | "closure" | "unknown";
	command?: string;
	source?: string;
	id?: number;
	closureJson?: any;
}

export interface IRouteWarning extends IRouteCuriosity {
	type: "no_winter_maintenance";
}

export interface IItemData {
	source: string;
	id: number;
	geometry: string;
	title: string;
	desc: string;
	favoriteId?: string;
	usertitle?: string;
	closures?: Array<IRouteClosure>;
	warnings?: Array<IRouteWarning>;
	route_part_ids?: Array<string>;
	commerce?: {
		country: string;
	};
	typeId: number;
	routeParams?: {
		criterion: number;
	};
	path?: Array<string>;
	tripData?: Array<any>;
	pubtData?: Array<any>;
	boatData?: Array<any>;
	routeData?: Array<{
		length: number;
		time: number;
	}>;
	images?: {
		"1x1": string;
		"3x2": string;
	};
	showTrip?: boolean;
	planTrip?: boolean;
	ind: number;
	position: number;
	favicon?: string;
	poisTitle: string;
	pois: Array<any>;
}

/**
 * Obal pro:
 * - zobrazeni vsech itemu - start, cily, prujezdni body, dole je zmenit smer
 * - nejspis staci state na teto urovni, do dalsich itemu uz pres forEach a volani nejake metody
 */
export default class Items {
	constructor(map) {
		// reference na route map
		this._map = map;
		this._dom = {
			container: node("div", { className: "route-items" }),
			itemsList: node("div", { className: "route-items-list" }),
			buttons: node("div", { className: "buttons" }),
			changeDir: node("button", { className: "reverse" }),
			booking: node("span", { className: "booking-placeholder" }),
			printLine: node("div", { className: "route-print-line" })
		};
		this._items = [];
		this._lids = [];
		this._editItem = null;
		this._reorder = null;
		// dad
		this._reorderOptions = {
			scrollSpeed: 35, // 6
			ghostProcess: node => {
				let w = this._items[0].container.offsetWidth;
				node.style.width = w + "px";
				return node;
			},
			direction: "y",
			handleClass: "dad-handle"
		};
		this._readOnly = false;

		this._build();
		this._setListeners();
	}

	destroy() {
		Mapy.CML.removeListeners(this._lids);
		this._dom.container.remove();
	}

	get container() {
		return this._dom.container;
	}

	get itemsList() {
		return this._dom.itemsList;
	}

	get defaultState() {
		return {
			items: [],
			editItems: null,
			hoverInd: -1 // def.
		};
	}

	get readOnly() {
		return this._readOnly;
	}

	/**
	 * Nastaveni itemu - editacni mod.
	 *
	 * @param   {PlusItem}  plusItem Vybrany item
	 * @param   {Boolean}  state Stav true/false
	 */
	setEditState(plusItem, state) {
		if (state && this._editItem) {
			this._editItem.cancelEdit();
		}
		this._editItem = state ? plusItem : null;
		this._dom.container.classList[state ? "add" : "remove"]("edit-mode");

		if (this._reorder) {
			this._reorder.setEnable(!state && !this._readOnly);
		}

		let items = [];
		let editItems = [];

		this._items.forEach(item => {
			let itemState = item.state;

			if (itemState || (!itemState && state && item == plusItem)) {
				items.push(item);
				editItems.push(itemState || { plus: true });
			}
		});

		let len = items.length;
		items.forEach((i, ind) => {
			i.setPosition(ind == 0 ? ROUTE_CONST.position.start : (ind == len - 1 ? ROUTE_CONST.position.end : ROUTE_CONST.position.middle), ind);
		});

		Mapy.CML.state = {
			route: {
				editItems: state ? editItems : null
			}
		};
	}

	/**
	 * Update stavu - volaji si itemy po zmene.
	 *
	 * @param {Object} [ownState] Vlastni stav pro route
	 * @param {Boolean} [itemToScroll] Spocitat index pro scroll podle prazdneho itemu
	 */
	updateState(ownState, itemToScroll?) {
		if (this._editItem) {
			this._editItem.cancelEdit();
			this.setEditState(this._editItem);
		}

		let state = {
			route: Object.assign({
				// jelikoz je zmena z potomku -> uz nejsou relevantni
				// likeData: null,
				scroll: false,
				items: []
			}, ownState)
		};

		this._items.forEach((item, ind) => {
			let itemState = item.state;

			if (itemState) {
				state.route.items.push(itemState);
			}

			if (itemToScroll && itemToScroll == item) {
				state.route.scroll = ind;
			}
		});

		if (state.route.items.length < 2) {
			state.route.responseData = [];

			if (state.route.items.length == 1) {
				if (!state.route.items[0].tripData) {
					state.route.items[0].tripData = [];
				}

				if (!state.route.items[0].path) {
					state.route.items[0].path = [];
				}

				state.route.items[0].path[Mapy.CML.state.route.index] = "";
			}
			else {
			}
		}

		if (Mapy.CML.state.route.likeData) {
			if ("owner_name" in Mapy.CML.state.route.likeData) {
				Mapy.CML.state = {
					route: {
						likeData: null,
						likeDataChange: false
					}
				};
			}
			else {
				state.route.likeDataChange = true;
			}
			Mapy.getComponent("dimcurator").setState();
		}

		Mapy.CML.state = state;
	}

	/**
	 * Uprava poradi u PUBT.
	 *
	 * @param   {Item}  item Volany item
	 * @param   {Number}  direction Smer
	 */
	updatePubtDirection(item, direction) {
		let pubtItems = this._items.filter(i => i instanceof ItemPubt);
		let state = Mapy.CML.state;
		let paramsPubtIndex = state.route.pubtIndex || [];
		let pubtIndex = [];

		pubtItems.forEach((i, ind) => {
			let value = paramsPubtIndex[ind] || 0;
			if (i == item) {
				value += direction;
			}
			pubtIndex.push(value);
		});
		// nakonec vzdycky dame 0
		pubtIndex.push(0);
		Mapy.CML.state = {
			route: {
				pubtIndex
			}
		};
	}

	focusEmptyItem() {
		// je treba to mit s timeoutem, aby se to skutecne stalo a ne aby to jeste manipulace s DOMem stihla zkazit
		setTimeout(() => {
			if (Mapy.getComponent("layout").getWidth() != 0 && !!Mapy.getComponent("history") && !Mapy.getComponent("history").isFromHistory()) {
				for (let i = 0; i < this._items.length; i++) {
					if (this._items[i] instanceof ItemEmpty) {
						this._items[i].focus();
						break;
					}
				}
			}
		}, 0);
	}

	_build() {
		this._dom.changeDir.appendChild(icon("reverse"));
		this._dom.container.appendChild(this._dom.itemsList);
		this._dom.container.appendChild(this._dom.buttons);
		this._dom.changeDir.addEventListener("click", e => {
			this._changeDirClick(e);
		});
	}

	/**
	 * Hlavni funkce - vytvoreni vsech itemu ze stavu.
	 *
	 * @param   {Array}  items
	 * @param   {Boolean} [scrollIndex] Na jaky item nascrollovat?
	 */
	_makeItems(items, scrollIndex, readOnly) {
		while (this._items.length) {
			let item = this._items.pop();
			item.destroy();
		}

		let itemsList = [];
		let pubtItems = [];
		let itemsLen = items.length;
		let isTrip = false;
		let focusItem = null;
		const routeState = Mapy.CML.state.route;
		const oldPubtIndex = routeState.pubtIndex;
		const newPubtIndex = [];

		items.forEach((data, ind) => {
			data.showTrip = itemsLen == 1;
			data.ind = ind;

			if (itemsLen == 1 && data.position) {
				data.position = data.position;
			}
			else if (!ind) {
				data.position = ROUTE_CONST.position.start;
			}
			else {
				data.position = ind == itemsLen - 1 ? ROUTE_CONST.position.end : ROUTE_CONST.position.middle;
			}

			if (itemsLen == 1 && data.tripData && data.tripData[routeState.index]) {
				isTrip = true;
				itemsList.push(new ItemTrip(this, data));
			}
			else {
				itemsList.push(new ItemPoint(this, data, readOnly));
			}
		});

		if (!isTrip) {
			if (itemsList.length < 2) {
				// prazdne itemy
				let diff = 2 - itemsList.length;

				for (let i = 0; i < diff; i++) {
					if (diff == 1) {
						if (itemsList[0].state.position == ROUTE_CONST.position.start) {
							focusItem = new ItemEmpty(this, { position: ROUTE_CONST.position.end, focus: true });
							itemsList.push(focusItem);
						}
						else {
							focusItem = new ItemEmpty(this, { position: ROUTE_CONST.position.start, focus: true });
							itemsList.unshift(focusItem);
						}
					}
					else {
						let item = new ItemEmpty(this, { position: !i ? ROUTE_CONST.position.start : ROUTE_CONST.position.end });
						itemsList.push(item);
						if (!i) {
							focusItem = item;
						}
					}
				}
			}
			else {
				// popridavame pluska mezi itemy
				let newList = [];
				let ptr = 0;

				while (itemsList.length) {
					let item = itemsList.shift();

					if (ptr > 0) {
						let plusState = {};
						newPubtIndex.push(oldPubtIndex.length > ptr - 1 ? oldPubtIndex[ptr - 1] : 0);

						if (items[ptr - 1].routeData && items[ptr - 1].routeData[routeState.index] && itemsLen > 2) {
							plusState.routeData = [];
							plusState.routeData[routeState.index] = items[ptr - 1].routeData[routeState.index];
						}

						let isPubt = items[ptr - 1].pubtData && items[ptr - 1].pubtData.length ? items[ptr - 1].pubtData[routeState.index] : false;
						let isBoat = items[ptr - 1].boatData && items[ptr - 1].boatData.length ? items[ptr - 1].boatData[routeState.index] : false;
						let plusItem = new ItemPlus(this, routeState, plusState, isPubt || isBoat);

						newList.push(plusItem);

						if (isPubt) {
							let pubtItem = new ItemPubt(this, JSON.parse(items[ptr - 1].pubtData[routeState.index]), this._map);
							plusItem.item = pubtItem;
							newList.push(pubtItem);
							pubtItems.push(pubtItem);
						} else if (isBoat) {
							let boatItem = new ItemBoat(this, items[ptr - 1].boatData[routeState.index]);
							plusItem.item = boatItem;
							newList.push(boatItem);
						}
					}

					newList.push(item);
					ptr++;
				}

				newList.push(new ItemPlus(this, routeState));
				itemsList = newList;
			}
		}

		Mapy.CML.state = {
			route: {
				pubtIndex: newPubtIndex
			}
		};

		this._items = itemsList;

		// nastavime sousedici body pro pubt -> musime mit this._items naplneny
		pubtItems.forEach(pubtItem => {
			pubtItem.siblings = this._getPubtSiblings(pubtItem);
		});

		// mame hotovy seznam, vlozime do domu
		this._items.forEach(item => {
			this._dom.itemsList.appendChild(item.container);
		});

		this._dom.itemsList.classList[isTrip ? "add" : "remove"]("trip");
		this._dom.itemsList.classList[!isTrip && this._items.length <= 2 ? "add" : "remove"]("unrouted");

		if (focusItem && Mapy.getComponent("layout").getWidth() > 0) {
			focusItem.focus();
		}

		if (!isTrip && typeof scrollIndex === "number" && scrollIndex >= 0 && scrollIndex < this._items.length) {
			let scrollPtr = 0;

			this._items.every(i => {
				if (i instanceof ItemPoint) {
					if (scrollPtr == scrollIndex) {
						i.container.scrollIntoView();
						return false;
					}
					scrollPtr++;
				}
				return true;
			});
		}

		if (this._reorder) {
			this._reorder.$destructor();
			this._reorder = null;
		}

		// pokud je response, nabidneme vymenu smeru
		if (items.length >= 2 && !isTrip) {
			this._dom.buttons.append(this._dom.booking);

			if (readOnly) {
				this._dom.changeDir.remove();
			} else {
				this._dom.buttons.append(this._dom.changeDir);
			}
		} else {
			this._dom.booking.remove();
			this._dom.changeDir.remove();
		}

		// pokud neni vylet -> drag and drop
		if (!isTrip) {
			this._reorder = new RouteReorder(this._dom.itemsList, this._reorderOptions, (name, data) => {
				this._reorderCb(name, data);
			});
		}
	}

	/**
	 * Callback po DAD
	 *
	 * @param   {String}  name Nazev eventu
	 * @param   {Object}  data Data eventu
	 */
	_reorderCb(name, data) {
		switch (name) {
			case "start-dragging":
				this._dom.container.classList.add("dragging");
				break;
			case "item-click":
				this._dom.container.classList.remove("dragging");
				break;
			case "end-dragging":
				this._dom.container.classList.remove("dragging");

				let items = Mapy.CML.state.route.items;

				if (data) {
					let itemsPos;

					if (items.length == 1) {
						itemsPos = items;
						itemsPos[0].position = this._items[0].state ? ROUTE_CONST.position.end : ROUTE_CONST.position.start;
					}
					else if (!items.length) {
						this._makeItems([]);
						return;
					}
					else {
						let reorderItem = items[data.ind];
						items.splice(data.ind, 1);
						items.splice(data.value, 0, reorderItem);
					}

					Mapy.CML.state = {
						route: {
							items,
							zoom: true,
						}
					};

					Mapy.getComponent("history").save();
				}
				else if (items.length) {
					this._makeItems(items);
				}
				break;
		}
	}

	/**
	 * Nastaveni posluchacu.
	 */
	_setListeners() {
		this._lids.push(Mapy.CML.addListener((items, state) => {
			const readOnly = state.route.readOnly;

			this._readOnly = readOnly;
			this._makeItems(items, state.route.scroll, readOnly);

			if (state.route.items.length > 1) {
				this.setEditState(undefined, false);
			}

			this._dom.container.classList[state.route.readOnly ? "add" : "remove"]("read-only");
		}, "route.items"));

		this._lids.push(Mapy.CML.addListener((hoverInd, state) => {
			if (!state.route.active) {
				return;
			}

			let ptr = 0;

			this._items.forEach(i => {
				if (i instanceof ItemPoint) {
					i.setActive(hoverInd == -1 ? false : ptr == hoverInd);
					ptr++;
				}
			});
		}, "route.hoverInd"));

		this._lids.push(Mapy.CML.addListener(params => {
			this.focusEmptyItem();
		}, "route.params"));

		this._lids.push(Mapy.CML.addListener((print, state) => {
			this._dom.container.classList[print ? "add" : "remove"]("print-mode");
			this._print(print, state.route);
		}, "route.print"));

		this._lids.push(Mapy.CML.addListener((responseData, state) => {
			const items = state.route.items;

			if (responseData.length && items.length && this._dom.booking.parentNode) {
				this._dom.booking.innerHTML = "";
				this._dom.booking.append(createRouteBookingLink(items[items.length - 1]));
			}
		}, "route.responseData"));
	}

	/**
	 * Zmena poradi trasy.
	 *
	 * @param   {Event}  e
	 */
	_changeDirClick(e) {
		let items = Mapy.CML.state.route.items;
		items.reverse();

		Mapy.CML.state = {
			route: {
				items,
				zoom: true,
			}
		};
	}

	/**
	 * Zjisteni sousedicich potomku pro pubt - hleda okolni body.
	 *
	 * @param   {RouteItem}  item Hledany item
	 *
	 * @return  {Object}
	 */
	_getPubtSiblings(item) {
		let output = {
			prevIsFirst: false,
			nextIsLast: false,
			prev: null,
			next: null
		};
		let fullItems = [];
		let index = -1;

		for (let i = 0, max = this._items.length; i < max; i++) {
			let isFull = this._items[i] instanceof ItemPoint;

			if (isFull) {
				fullItems.push(this._items[i]);
			}

			if (index == -1 && this._items[i] == item) {
				index = fullItems.length;
			}
		}

		if (index != -1) {
			output.prevIsFirst = index == 1;
			output.nextIsLast = index == fullItems.length - 1;
			output.prev = fullItems[index - 1];
			output.next = fullItems[index];
		}

		return output;
	}

	_print(state, routeState) {
		if (state && routeState.responseData.length && Mapy.getComponent("print").mode !== 4) {
			// ikonka pro tisk
			let svgIcon = icon(paramTypeToSvg(routeState));
			svgIcon.classList.add("route-icon");
			svgIcon.classList.add("route-icon-print");
			svgIcon.style.width = "24px";
			svgIcon.style.height = "24px";
			let data = routeState.responseData[routeState.index];
			let length = data.totalLength;
			let time = data.totalTime;
			let title = node("h2");
			title.appendChild(svgIcon);
			title.appendChild(node("span", { className: "time", textContent: standardTimeFormat(timeWithUserSpeed(time, getCriterion(routeState))).string }));
			title.innerHTML += " &ndash; " + standardDistanceFormat(length).string;
			this._dom.printLine.innerHTML = "";
			this._dom.printLine.appendChild(title);
			this._dom.container.insertBefore(this._dom.printLine, this._dom.container.firstChild);
		}
		else {
			this._dom.printLine.innerHTML = "";
			this._dom.printLine.remove();
		}
	}
}
